import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Modal,
  Box,
  Typography,
  Slide,
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Card,
  CardContent,
  IconButton,
  Select,
  MenuItem,
  InputAdornment,
} from "@mui/material";
import { AddPhotoAlternate, DeleteOutline } from "@mui/icons-material";
import { clientApis } from "../../Data/axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { getUserInfo } from "../../Data/UserData";

export default function AddClients({ open, handleClose, onClientAdded }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [gender, setGender] = useState("");
  const [state, setState] = useState("");
  const [pinCode, setPinCode] = useState("");
  const [address, setAddress] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [website, setWebsite] = useState("");
  const [taxName, setTaxName] = useState("");
  const [taxNumber, setTaxNumber] = useState("");
  const [industryType, setIndustryType] = useState("");
  const [shipping, setShipping] = useState("");
  const [isLogin, setIsLogin] = useState("1");
  const [emailNot, setEmailNot] = useState("1");
  const [description, setDescription] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [industryTypeData, setIndustryTypeData] = useState([]);

  const indianStates = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
    "Andaman and Nicobar Islands",
    "Chandigarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Jammu and Kashmir",
    "Ladakh",
    "Lakshadweep",
    "Puducherry",
  ];

  const genderOptions = [
    { id: "1", label: "Male" },
    { id: "2", label: "Female" },
    { id: "3", label: "Others" },
  ];

  // Fetch industry types on component mount
  useEffect(() => {
    fetchIndustryTypes();
  }, []);

  const fetchIndustryTypes = async () => {
    try {
      const response = await clientApis.industryAll();
      if (response && response.data) {
        setIndustryTypeData(response.data);
      }
    } catch (error) {
      console.error("Error fetching industry types:", error);
    }
  };

  const handleFormReset = () => {
    setName("");
    setEmail("");
    setMobile("");
    setGender("");
    setState("");
    setPinCode("");
    setAddress("");
    setCompanyName("");
    setCompanyEmail("");
    setPhoneNumber("");
    setWebsite("");
    setTaxName("");
    setTaxNumber("");
    setIndustryType("");
    setShipping("");
    setIsLogin("1");
    setEmailNot("1");
    setDescription("");
    setProfileImage(null);
  };

  const handleCloseModal = () => {
    handleFormReset();
    handleClose();
  };

  const handleFileChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      setProfileImage(file);
    }
  };

  const handleFileRemove = () => {
    setProfileImage(null);
  };

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
      ["link"],
      ["clean"],
    ],
  };

  const handleSaveClient = async () => {
    try {
      if (!name || !mobile || !email || !companyEmail || !phoneNumber) {
        alert("Please fill in all required fields");
        return;
      }

      const formData = new FormData();
      formData.append("username", name);
      formData.append("email", email);
      formData.append("phone", mobile);
      formData.append("address", address);
      formData.append("state", state);
      formData.append("pincode", pinCode);
      formData.append("company_email", companyEmail);
      formData.append("company_phone", phoneNumber);
      formData.append("company_website", website);
      formData.append("gender", gender);
      formData.append("ref", getUserInfo());
      formData.append("industry_type", industryType || "2"); // Default to "2" if not selected
      formData.append("company_name", companyName);
      formData.append("tax_name", taxName);
      formData.append("tax_number", taxNumber);
      formData.append("allow_login", isLogin);
      formData.append("notification", emailNot);
      formData.append("note", description);

      if (profileImage) {
        formData.append("image", profileImage);
      }

      console.log("Submitting client data:");
      for (let [key, value] of formData.entries()) {
        if (value instanceof File) {
          console.log(`${key}: File - ${value.name} (${value.size} bytes)`);
        } else {
          console.log(`${key}: ${value}`);
        }
      }

      const response = await clientApis.add(formData);
      // Check for various success indicators since API might return different structures
      const isSuccess = response && (
        response.success === true ||
        response.status === true ||
        response.message?.toLowerCase().includes('success') ||
        response.id ||
        response.data?.id
      );

      if (isSuccess) {
        alert("Client added successfully!");
        if (onClientAdded) onClientAdded();
        handleCloseModal();
      } else {
        const errorMessage =
          response?.message || response?.error || "Failed to add client. Please try again.";
        console.error("API Error:", response);
        alert(errorMessage);
      }
    } catch (error) {
      console.error("Error adding client:", error);
      let errorMessage = "An error occurred while adding the client.";
      if (error.response) {
        console.error("Error response:", error.response.data);
        errorMessage = error.response.data?.message || errorMessage;
      } else if (error.request) {
        console.error("Error request:", error.request);
        errorMessage = "No response received from server. Please check your connection.";
      }

      alert(errorMessage);
    }
  };

  const inputProps = {
    sx: {
      bgcolor: "#f9f9f9",
      "& .MuiOutlinedInput-root": {
        "& fieldset": {
          borderColor: "#e0e0e0",
        },
        "&:hover fieldset": {
          borderColor: "#bdbdbd",
        },
      },
      "& .MuiInputBase-input": {
        color: "#424242",
      },
    },
  };

  const FileInput = ({ title, file, onFileChange, onFileRemove, accept }) => (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body1" mb={1} sx={{ color: "#212121" }}>
        {title}
      </Typography>
      <Box
        sx={{
          border: "1px dashed #bdbdbd",
          borderRadius: 1,
          p: 2,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "#f5f5f5",
          position: "relative",
        }}
      >
        {file ? (
          <Box sx={{ width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Typography
                variant="body2"
                color="textSecondary"
                sx={{
                  maxWidth: "70%",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {file.name}
              </Typography>
              <IconButton
                onClick={() => onFileRemove()}
                size="small"
                color="error"
              >
                <DeleteOutline />
              </IconButton>
            </Box>
            {file.type.startsWith("image/") && (
              <Box
                sx={{
                  width: "100%",
                  height: 100,
                  backgroundImage: `url(${URL.createObjectURL(file)})`,
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              />
            )}
          </Box>
        ) : (
          <>
            <input
              type="file"
              id={`file-input-${title.replace(/\s+/g, "-").toLowerCase()}`}
              style={{ display: "none" }}
              onChange={(e) => onFileChange(e)}
              accept={accept || "image/*"}
            />
            <label
              htmlFor={`file-input-${title.replace(/\s+/g, "-").toLowerCase()}`}
            >
              <Button
                variant="text"
                component="span"
                startIcon={<AddPhotoAlternate />}
                sx={{ color: "#1d82f5" }}
              >
                Upload File
              </Button>
            </label>
            <Typography variant="caption" color="textSecondary" sx={{ mt: 1 }}>
              Click to upload or drag and drop
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );

  return (
    <Modal open={open} onClose={handleCloseModal} closeAfterTransition>
      <Slide direction="left" in={open}>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "85%",
            height: "100%",
            bgcolor: "#f5f5f5",
            boxShadow: 24,
            p: 4,
            overflow: "auto",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
          >
            <Typography variant="h3" component="h2" sx={{ color: "#212121" }}>
              Add New Client
            </Typography>
            <Button
              onClick={handleCloseModal}
              variant="outlined"
              sx={{
                borderColor: "#bdbdbd",
                color: "#424242",
                "&:hover": {
                  borderColor: "#9e9e9e",
                  bgcolor: "rgba(0, 0, 0, 0.04)",
                },
              }}
            >
              Close
            </Button>
          </Box>
          <Card
            sx={{
              p: 2,
              bgcolor: "#ffffff",
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
            }}
          >
            <CardContent>
              {/* Personal Information */}
              <Box sx={{ mb: 4 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography variant="h6" sx={{ color: "#212121", mb: 2 }}>
                      Personal Information
                    </Typography>
                  </Grid>

                  {/* Profile Image */}
                  <Grid item xs={12} md={3}>
                    <FileInput
                      title="Profile Image"
                      file={profileImage}
                      onFileChange={handleFileChange}
                      onFileRemove={handleFileRemove}
                      accept="image/*"
                    />
                  </Grid>

                  {/* Name */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Client Name <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter name"
                      size="small"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Email */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Email <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="example@email.com"
                      size="small"
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Phone */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Mobile No <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="+91 1234567890"
                      size="small"
                      value={mobile}
                      onChange={(e) => setMobile(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Gender */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Gender
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                        displayEmpty
                        sx={{
                          backgroundColor: "#f9f9f9",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#bdbdbd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1d82f5",
                          },
                          fontFamily: "Ubuntu, sans-serif",
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <em
                                style={{
                                  color: "#757575",
                                  fontFamily: "Ubuntu, sans-serif",
                                }}
                              >
                                Select gender
                              </em>
                            );
                          }
                          return genderOptions.find(option => option.id === selected)?.label || selected;
                        }}
                      >
                        <MenuItem
                          disabled
                          value=""
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          <em>Select gender</em>
                        </MenuItem>
                        {genderOptions.map((option) => (
                          <MenuItem
                            key={option.id}
                            value={option.id}
                            sx={{ fontFamily: "Ubuntu, sans-serif" }}
                          >
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Login Allowed */}
                  <Grid item xs={12} md={4.5}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Login Allowed?
                    </Typography>
                    <FormControl>
                      <RadioGroup
                        row
                        value={isLogin}
                        onChange={(e) => setIsLogin(e.target.value)}
                      >
                        <FormControlLabel
                          value="1"
                          control={
                            <Radio
                              sx={{
                                color: "#9e9e9e",
                                "&.Mui-checked": { color: "#1d82f5" },
                              }}
                            />
                          }
                          label="Yes"
                          sx={{ color: "#424242" }}
                        />
                        <FormControlLabel
                          value="2"
                          control={
                            <Radio
                              sx={{
                                color: "#9e9e9e",
                                "&.Mui-checked": { color: "#1d82f5" },
                              }}
                            />
                          }
                          label="No"
                          sx={{ color: "#424242" }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>

                  {/* Email Notifications */}
                  <Grid item xs={12} md={4.5}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Receive Email Notifications?
                    </Typography>
                    <FormControl>
                      <RadioGroup
                        row
                        value={emailNot}
                        onChange={(e) => setEmailNot(e.target.value)}
                      >
                        <FormControlLabel
                          value="1"
                          control={
                            <Radio
                              sx={{
                                color: "#9e9e9e",
                                "&.Mui-checked": { color: "#1d82f5" },
                              }}
                            />
                          }
                          label="Yes"
                          sx={{ color: "#424242" }}
                        />
                        <FormControlLabel
                          value="2"
                          control={
                            <Radio
                              sx={{
                                color: "#9e9e9e",
                                "&.Mui-checked": { color: "#1d82f5" },
                              }}
                            />
                          }
                          label="No"
                          sx={{ color: "#424242" }}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>

              {/* Company Details */}
              <Box sx={{ mb: 4 }}>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography variant="h6" sx={{ color: "#212121", mb: 2 }}>
                      Company Details
                    </Typography>
                  </Grid>

                  {/* Company Name */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Company Name
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="e.g. Acme Corporation"
                      size="small"
                      value={companyName}
                      onChange={(e) => setCompanyName(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Company Email */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Company Email <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="company@example.com"
                      size="small"
                      type="email"
                      value={companyEmail}
                      onChange={(e) => setCompanyEmail(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Company Phone */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Office Phone Number <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="e.g. 98XXXXXXXX"
                      size="small"
                      value={phoneNumber}
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Website */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Official Website
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="www.example.com"
                      size="small"
                      value={website}
                      onChange={(e) => setWebsite(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Tax Name */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Tax Name
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="e.g. GST/VAT"
                      size="small"
                      value={taxName}
                      onChange={(e) => setTaxName(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Tax Number */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      GST/VAT Number
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="e.g. 1820XXXXXXXXX"
                      size="small"
                      value={taxNumber}
                      onChange={(e) => setTaxNumber(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Industry Type */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Industry Type
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={industryType}
                        onChange={(e) => setIndustryType(e.target.value)}
                        displayEmpty
                        sx={{
                          backgroundColor: "#f9f9f9",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#bdbdbd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1d82f5",
                          },
                          fontFamily: "Ubuntu, sans-serif",
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <em
                                style={{
                                  color: "#757575",
                                  fontFamily: "Ubuntu, sans-serif",
                                }}
                              >
                                Select industry type
                              </em>
                            );
                          }
                          const selectedIndustry = industryTypeData.find(
                            (item) => item.id.toString() === selected.toString()
                          );
                          return selectedIndustry?.name || selected;
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton edge="end">Add</IconButton>
                            </InputAdornment>
                          ),
                        }}
                      >
                        <MenuItem
                          disabled
                          value=""
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          <em>Select industry type</em>
                        </MenuItem>
                        {industryTypeData.map((item) => (
                          <MenuItem
                            key={item.id}
                            value={item.id}
                            sx={{ fontFamily: "Ubuntu, sans-serif" }}
                          >
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* State */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      State
                    </Typography>
                    <FormControl fullWidth size="small">
                      <Select
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        displayEmpty
                        sx={{
                          backgroundColor: "#f9f9f9",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#bdbdbd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1d82f5",
                          },
                          fontFamily: "Ubuntu, sans-serif",
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <em
                                style={{
                                  color: "#757575",
                                  fontFamily: "Ubuntu, sans-serif",
                                }}
                              >
                                Select state
                              </em>
                            );
                          }
                          return selected;
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                              width: 250,
                            },
                          },
                        }}
                      >
                        <MenuItem
                          disabled
                          value=""
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          <em>Select state</em>
                        </MenuItem>
                        {indianStates.map((stateName) => (
                          <MenuItem
                            key={stateName}
                            value={stateName}
                            sx={{ fontFamily: "Ubuntu, sans-serif" }}
                          >
                            {stateName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Pin Code */}
                  <Grid item xs={12} md={3}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Postal Code
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter pin code"
                      size="small"
                      value={pinCode}
                      onChange={(e) => setPinCode(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Billing Address */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Billing Address
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter full address"
                      size="small"
                      multiline
                      rows={2}
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Shipping Address */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Shipping Address
                    </Typography>
                    <TextField
                      fullWidth
                      placeholder="Enter shipping address"
                      size="small"
                      multiline
                      rows={2}
                      value={shipping}
                      onChange={(e) => setShipping(e.target.value)}
                      InputProps={inputProps}
                    />
                  </Grid>

                  {/* Description */}
                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{ color: "#212121" }}
                    >
                      Description <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <Box
                      sx={{
                        ".ql-toolbar": {
                          borderColor: "#e0e0e0",
                          borderTopLeftRadius: "4px",
                          borderTopRightRadius: "4px",
                          bgcolor: "#f9f9f9",
                        },
                        ".ql-container": {
                          borderColor: "#e0e0e0",
                          borderBottomLeftRadius: "4px",
                          borderBottomRightRadius: "4px",
                          bgcolor: "#ffffff",
                          color: "#212121",
                          minHeight: "120px",
                        },
                      }}
                    >
                      <ReactQuill
                        value={description}
                        onChange={setDescription}
                        modules={modules}
                        theme="snow"
                        placeholder="Type here..."
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>

              {/* Form buttons */}
              <Box display="flex" gap={2} mt={4}>
                <Button
                  variant="contained"
                  onClick={handleSaveClient}
                  sx={{
                    bgcolor: "#4285F4",
                    color: "white",
                    "&:hover": { bgcolor: "#3367D6" },
                    fontWeight: 500,
                    textTransform: "none",
                    padding: "8px 16px",
                  }}
                >
                  Save
                </Button>
                <Button
                  variant="outlined"
                  onClick={handleCloseModal}
                  sx={{
                    borderColor: "#bdbdbd",
                    color: "#424242",
                    "&:hover": {
                      borderColor: "#9e9e9e",
                      bgcolor: "rgba(0, 0, 0, 0.04)",
                    },
                    textTransform: "none",
                    padding: "8px 16px",
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Slide>
    </Modal>
  );
}